<template>
  <div
    class="flex flex-wrap items-center gap-x-3 gap-y-2 rounded-lg border border-blue-200 bg-blue-50 px-4 py-2.5 mb-3 text-sm"
    data-cy="multi-pay-banner"
  >
    <i class="fa-regular fa-check-double text-blue-700" aria-hidden="true"></i>
    <span class="font-semibold text-blue-900" data-cy="multi-pay-banner-count">
      {{ count }} {{ count === 1 ? "invoice" : "invoices" }} selected
    </span>
    <span class="text-blue-300">·</span>
    <span
      class="font-mono tabular-nums text-blue-900"
      data-cy="multi-pay-banner-total"
    >
      <template v-if="loading">…</template>
      <template v-else>{{ dollars(outstandingCents) }} outstanding</template>
    </span>
    <button
      type="button"
      class="rounded-full border border-blue-200 bg-white px-3 py-0.5 text-xs font-medium text-blue-900 hover:bg-blue-100"
      data-cy="multi-pay-clear"
      @click="$emit('clear')"
    >
      Clear
    </button>
    <span
      v-if="applyDisabledReason"
      class="text-xs text-amber-700"
      data-cy="multi-pay-disabled-reason"
    >
      {{ applyDisabledReason }}
    </span>
    <button
      type="button"
      class="ml-auto rounded-md bg-blue-600 px-4 py-1.5 text-sm font-semibold text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50"
      data-cy="multi-pay-apply"
      :disabled="applyDisabled || loading"
      @click="$emit('apply')"
    >
      <i class="fa-regular fa-dollar-sign mr-1" aria-hidden="true"></i>
      Apply payment
    </button>
  </div>
</template>

<script setup lang="ts">
import { dollars } from "@/mixins";

withDefaults(
  defineProps<{
    count: number;
    outstandingCents: number;
    loading?: boolean;
    applyDisabled?: boolean;
    applyDisabledReason?: string;
  }>(),
  {
    loading: false,
    applyDisabled: false,
    applyDisabledReason: ""
  }
);

defineEmits<{
  (e: "clear"): void;
  (e: "apply"): void;
}>();
</script>
